/** Baked at `react-scripts build` from REACT_APP_CACHEBUST (see Dockerfile / docker-compose). */
export const APP_BUILD_ID = process.env.REACT_APP_CACHEBUST || 'local';
